module.exports = __webpack_public_path__ + "img/cursos.17d97a45.jpg";